import script from "./DocEditNew.vue?vue&type=script&lang=tsx"
export * from "./DocEditNew.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__